






























































































































import Component from 'vue-class-component';
import { EditPage } from '@/components/base/edit/edit-page';
import * as ent from '@/entities';
import siteTypesApi from '@/api/site-types.api';
import sitesApi from '@/api/sites.api';
import {IConfirm, IDictionary, IFormControl} from '@/entities';
import * as types from '@/store/types';
import { mapGetters } from 'vuex';
import {IFeeGeosListModel} from '@/entities/fee-geos';


@Component({
     computed: mapGetters({
        superadminPermissions: types.AUTH_HAS_SUPERADMIN_PERMISSIONS,
    })
})
export default class SiteTypesEdit extends EditPage {
    public useApproveSale: boolean = false;

    get siteId(): number {
        return Number.parseInt(this.$route.params.siteId, 10);
    }

    get parentPath(): string {
        return `/app/sites/${this.siteId}/types`;
    }

    public formState: ent.IDictionary<ent.IFormControl> = {
        typename: {
            key: 'typename',
            label: `Link Name`,
            value: '',
            validators: 'required'
        },
        typealias: {
            key: 'typealias',
            label: 'Link Alias',
            value: '',
            validators: 'required'
        },
        bbrCh: {
            key: 'bbrCh',
            label: 'Integration channel',
            value: '',
            validators: ''
        },
        username: {
            key: 'username',
            label: 'Username',
            value: '',
            validators: 'required'
        },
        url: {
            key: 'url',
            label: 'Link URL',
            value: '',
            validators: 'required|url'
        },
        payout: {
            key: 'payout',
            label: 'Payout (₱)',
            value: 0,
            validators: 'required|decimal|min_value:0'
        },
        earning: {
            key: 'earning',
            label: 'Earning ($)',
            value: 0,
            validators: 'required|decimal|min_value:0'
        },
        lpp: {
            key: 'lpp',
            label: 'lpp',
            value: 1,
            validators: 'required|integer|min_value:0'
        },
        bonusPayout: {
            key: 'bonusPayout',
            label: 'Bonus Payout (₱)',
            value: 0,
            validators: 'decimal|min_value:0'
        },
        bonusEarning: {
            key: 'bonusEarning',
            label: 'Bonus Earning ($)',
            value: 0,
            validators: 'decimal|min_value:0'
        },
        bonusLpp: {
            key: 'bonusLpp',
            label: 'Bonus lpp',
            value: 1,
            validators: 'integer|min_value:0'
        },
        active: {
            key: 'active',
            label: 'Activated',
            value: false
        },
        bonus: {
            key: 'bonus',
            label: 'Bonus',
            value: false
        },
        showNoSalesStat: {
            key: 'showNoSalesStat',
            label: 'Show No Sales Stat',
            value: false
        },
        status: {
            key: 'activated',
            label: 'Activated',
            value: ent.SiteStatus.Suspended
        },
        feeGeos: {
            key: 'feeGeos',
            label: `feeGeos`,
            value: []
        },
    };

    public feeGeosState: Array<ent.IDictionary<ent.IFormControl>> = [];

    public submit() {
        if (this.feeGeosState.length > 0) {
            this.formState.feeGeos.value = this.feeGeosState.map(
                (controls: IDictionary<IFormControl>) => {
                    const res = {};
                    Object.keys(controls).forEach((key) => res[controls[key].key] = controls[key].value);
                    return res;
                }
            );
        } else {
            this.formState.feeGeos.value = [];
        }
        super.submit();
    }

    public async created() {
        const site = await sitesApi.get(this.siteId);
        this.useApproveSale = site.useApproveSale;
        this.updateFormStateLabels(this.useApproveSale);
        await super.created();

        if (this.isNew) {
            this.formState.status.value = ent.SiteStatus.Activated;
        } else {
            this.feeGeosState.push(...this.model.feeGeos.map(
                (model) => this.createFeeGeoState(model.geo, model.earning, model.payout))
            );
        }
    }

    // TODO own resourse service will be nice for api calls
    public detail(id: number): Promise<ent.ISiteTypeDetailModel> {
        return siteTypesApi.get(id);
    }

    public create(body: any): Promise<number> {
        return siteTypesApi.create({ ...body, siteId: this.siteId });
    }

    public update(body: any): Promise<number> {
        return siteTypesApi.update(this.id, body);
    }


    public deleteType() {
        let afterFn = async (closeFn: () => void) => {
            try {
                await siteTypesApi.delete(this.id);
                this.$router.push(this.parentPath);
            } finally {
                closeFn();
            }
        };
        let payload: IConfirm = {
            heading: 'Are you sure you want delete site link?',
            afterFn
        };
        this.$store.dispatch(types.SHOW_CONFIRM, payload);
    }

    public addGeo() {
        this.feeGeosState.push(this.createFeeGeoState());
    }

    public deleteGeo(id: number) {
        this.feeGeosState.splice(id, 1);
    }

    private updateFormStateLabels(useApproveSale) {
        this.formState.bonus.label = !useApproveSale ? 'Bonus' : 'Day#2 Sale';
        this.formState.bonusPayout.label = !useApproveSale
            ? 'Bonus Payout (₱)'
            : 'Day#2 Payout (₱)';
        this.formState.bonusEarning.label = !useApproveSale
            ? 'Bonus Earning ($)'
            : 'Day#2 Earning ($)';
        this.formState.bonusLpp.label = !useApproveSale
            ? 'Bonus lpp'
            : 'Day#2 lpp';
    }


    private createFeeGeoState(geo: string = '', earning: string = '', payout: string = '') {
        return {
            geo: {
                key: 'geo',
                label: 'Geo  Code (US, IT, MX...)',
                value: geo,
                validators: 'required'
            },
            earning: {
                key: 'earning',
                label: 'Earning ($)',
                value: earning,
                validators: ''
            },
            payout: {
                key: 'payout',
                label: 'Payout (₱)',
                value: payout,
                validators: ''
            }
        };
    }
}
